import Transporter from "./Transporter"

const FilterResults = ({ transporters, setFilterFn }) => {
  const hasResult = transporters && transporters.length > 0

  return (
    <div>
      <button className="btn-restart" onClick={ () => setFilterFn({ choice: "reset" }) }>Start again</button>
      <br />
      <h2 className="selection-results">My results</h2>
      { !hasResult && (
        <div className="selection-noresults">No search results</div>
      )}
      { hasResult && (
        transporters.map(transporter => (
          <div>
            <Transporter
              key={transporter.id}
              transporter={transporter}
            />
          </div>
        ))
      )}
    </div>
  )
}

export default FilterResults
